import axios from "axios";
import * as actionType from "../redux/action";
import { Business } from "../Items/Business";

const API_URL = "https://app.mamadapp.co.il/api/Business"; // תעדכן לפי הכתובת שלך


//  export const getBusinesses = () => async (dispatch: any) => {
//     try {
//           const response = await axios.get(API_URL);
//           const data = response.data;
      
//           const businesses: Business[] = data.map((b: any) => ({
//             id: b.id,
//             name: b.name,
//             nameOfOwner: b.nameOfOwner,
//             businessTypeId: b.businessTypeId,
//             businessType: b.businessType
//               ? { id: b.businessType.id, name: b.businessType.name }
//               : null,
//             email: b.email,
//             phoneOfOwner: b.phoneOfOwner,
//             phone: b.phone,
//             isShow: b.isShow,
//           }));
      
//           dispatch({ type: actionType.GET_BUSINESSES, payload: businesses });
//     } catch (error) {
//           console.error("Error fetching businesses", error);
//     }
//  };

export const getBusinesses = () => async (dispatch: any) => {
    try {
        const response = await axios.get(API_URL);
        const data = response.data;

        const businesses: Business[] = data.map((b: any) => ({
            id: b.id,
            name: b.name,
            nameOfOwner: b.nameOfOwner,
            businessTypeId: b.businessTypeId,
            businessType: b.businessType
                ? { id: b.businessType.id, name: b.businessType.name }
                : null,
            email: b.email,
            phoneOfOwner: b.phoneOfOwner,
            phone: b.phone,
            address: b.address || "",               // ← כתובת
            paymentOptionId: b.paymentOptionId || 0, // ← סוג תשלום
            paymentOption: b.paymentOption
                ? { id: b.paymentOption.id, optionName: b.paymentOption.optionName }
                : null,
            notes: b.notes || "",                   // ← הערות
            uploadLogo: b.uploadLogo || "",         // ← לוגו
            isShow: b.isShow
        }));

        dispatch({ type: actionType.GET_BUSINESSES, payload: businesses });
    } catch (error) {
        console.error("Error fetching businesses", error);
    }
};

    export const addBusiness = (business: Business) => async (dispatch: any) => {
        try {
          
            const formData = new FormData();
            formData.append("Name", business.name);
            formData.append("NameOfOwner", business.nameOfOwner);
            formData.append("BusinessTypeId", business.businessTypeId.toString());
            formData.append("Email", business.email);
            formData.append("PhoneOfOwner", business.phoneOfOwner);
            formData.append("Phone", business.phone);
            formData.append("Address", business.address);
            formData.append("PaymentOptionId", business.paymentOptionId.toString());
            formData.append("Notes", business.notes || "");
            formData.append("IsShow", "true");
    
            if (business.uploadLogo) {
                formData.append("UploadLogo", business.uploadLogo);
            }
    
            const response = await axios.post(API_URL, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
    
            const newBusiness: Business = response.data;
            dispatch({ type: actionType.ADD_BUSINESS, payload: newBusiness });
        } catch (error) {
            console.error("Error adding business", error);
        }
    };
    

// export const editBusiness = (id: number, business: Business) => async (dispatch: any) => {
//     try {
//         const formData = new FormData();
//         formData.append("Name", business.name);
//         formData.append("NameOfOwner", business.nameOfOwner);
//         formData.append("BusinessTypeId", business.businessTypeId.toString());
//         formData.append("Email", business.email);
//         formData.append("PhoneOfOwner", business.phoneOfOwner);
//         formData.append("Phone", business.phone);
//         formData.append("Address", business.address);
//         formData.append("PaymentOptionId", business.paymentOptionId.toString());
//         formData.append("Notes", business.notes || "");
//         formData.append("IsShow", business.isShow.toString());

//         if (business.uploadLogo) {
//             formData.append("UploadLogo", business.uploadLogo);
//         }


//         const response = await axios.put(`${API_URL}/${id}`, formData, {
//             headers: { "Content-Type": "multipart/form-data" },
//         });

//         dispatch({ type: actionType.EDIT_BUSINESS, payload: response.data });
//     } catch (error) {
//         console.error("Error updating business", error);
//     }
// };
// export const editBusiness = (id: number, business: Business) => async (dispatch: any) => {
//     try {
//         const formData = new FormData();
//         formData.append("Name", business.name);
//         formData.append("NameOfOwner", business.nameOfOwner);
//         formData.append("BusinessTypeId", business.businessTypeId.toString());
//         formData.append("Email", business.email);
//         formData.append("PhoneOfOwner", business.phoneOfOwner);
//         formData.append("Phone", business.phone);
//         formData.append("Address", business.address);
//         formData.append("PaymentOptionId", business.paymentOptionId.toString());
//         formData.append("Notes", business.notes || "");
//         formData.append("IsShow", business.isShow.toString());

//         // כאן שולחים תמיד לוגו: קובץ חדש או כתובת קיימת
//         if (business.uploadLogo instanceof File) {
//             formData.append("UploadLogo", business.uploadLogo);
//         } else if (typeof business.uploadLogo === "string" && business.uploadLogo.trim() !== "") {
//             formData.append("UploadLogo", business.uploadLogo); // שולחים כתובת קיימת
//         }

//         const response = await axios.put(`${API_URL}/${id}`, formData, {
//             headers: { "Content-Type": "multipart/form-data" },
//         });

//         dispatch({ type: actionType.EDIT_BUSINESS, payload: response.data });
//     } catch (error) {
//         console.error("Error updating business", error);
//     }
// };
export const editBusiness = (id: number, business: Business) => async (dispatch: any) => {
    try {
        const formData = new FormData();
        formData.append("Name", business.name);
        formData.append("NameOfOwner", business.nameOfOwner);
        formData.append("BusinessTypeId", business.businessTypeId.toString());
        formData.append("Email", business.email);
        formData.append("PhoneOfOwner", business.phoneOfOwner);
        formData.append("Phone", business.phone);
        formData.append("Address", business.address);
        formData.append("PaymentOptionId", business.paymentOptionId.toString());
        formData.append("Notes", business.notes || "");
        formData.append("IsShow", business.isShow.toString());

        // שולחים את הלוגו רק אם זה קובץ חדש
        if (business.uploadLogo instanceof File) {
            formData.append("UploadLogo", business.uploadLogo);
        }

        const response = await axios.put(`${API_URL}/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });

        dispatch({ type: actionType.EDIT_BUSINESS, payload: response.data });
    } catch (error) {
        console.error("Error updating business", error);
    }
};



  export const deleteBusiness = (id: number) => async (dispatch: any) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      dispatch({ type: actionType.DELETE_BUSINESS, payload: id });
    } catch (error) {
      console.error("Error deleting business", error);
    }
  };

  export const toggleIsShow = (id: number) => async (dispatch: any) => {
    try {
        const response = await axios.patch(`${API_URL}/ToggleIsShow/${id}`, {});
        const toggledBusiness: Business = response.data;

        dispatch({ type: actionType.EDIT_BUSINESS, payload: toggledBusiness });

        return toggledBusiness;  // <--- מחזירים את ה-business
    } catch (error) {
        console.error("Error toggling isShow", error);
        return null;
    }
};
  

  export const getPaymentOptions = async (): Promise<{ id: number; optionName: string }[]> => {
    const response = await axios.get(`${API_URL}/PaymentOptions`);
    return response.data;
  };

  export const getBusinessTypes = async (): Promise<{ id: number; name: string }[]> => {
    const response = await axios.get(`${API_URL}/BusinessTypes`);
    return response.data;
  };
  

  







